<header>
  <h1>BANKING—BUILDING FUTURES EVERY DAY</h1>
</header>

@if (columns().length > 0) {
<section>
  @for (column of columns(); track trackByColumn($index, column)) {
  <div class="column" [class.column--bordered]="column.type === FooterMenuColumnType.Bordered">
    @if (column.label) {
    <h2>{{ column.label }}</h2>
    } @for (section of column.sections; track trackBySection($index, section)) {
    <div class="group">
      @if (section.label) {
      <h4>{{ section.label }}</h4>
      } @if (section.menu_items?.length) {
      <ul>
        @for (item of section.menu_items; track trackByMenuItem($index, item)) {
        <li>
          <a
            [routerLink]="item.url"
            [queryParams]="item.query_params"
            [class.link--uppercase]="item.type === MenuItemLinkType.Uppercase"
            [class.link--large]="item.type === MenuItemLinkType.Large"
            [target]="item.target || '_self'"
          >
            {{ item.label }}
          </a>
        </li>
        }
      </ul>
      }
    </div>
    }
  </div>
  }
</section>
}

<div class="social">
  <a href="https://www.facebook.com/PABankers/" target="_blank" aria-label="Facebook"><mat-icon svgIcon="facebook"></mat-icon></a>
  <a href="https://www.linkedin.com/company/pennsylvania-bankers-association" target="_blank" aria-label="LinkedIn"><mat-icon svgIcon="linkedin"></mat-icon></a>
</div>
<div class="nav">
  <div class="policy">
    <a routerLink="/info/privacy-policy">Privacy Policy</a>
  </div>
  <div class="terms">
    <a routerLink="/info/terms-of-use">Terms of Use</a>
  </div>
  <div class="about">
    <a routerLink="/info/about-this-site">About this Site</a>
  </div>
</div>
